import PropTypes from "prop-types";
import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../constants/colors";
import styl from "../../styl";

/**
 * @author Sandro Mennel
 * @param {Array} items list of { title, html } (html string) or { title, content } (react node) (required)
 * @example <AboAccordion items={[{ title: "Beschreibung", html: "<p>Text</p>" }]} />
 */
export default function AboAccordion({ items }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <Wrapper>
      {items.map((item, i) => {
        const isOpen = openIndex === i;
        return (
          <Item key={item.title}>
            <Header
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpenIndex(isOpen ? null : i)}
            >
              {item.title}
              <Chevron $open={isOpen} />
            </Header>
            {isOpen &&
              (item.html ? (
                <Content dangerouslySetInnerHTML={{ __html: item.html }} />
              ) : (
                <Content>{item.content}</Content>
              ))}
          </Item>
        );
      })}
    </Wrapper>
  );
}

AboAccordion.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      html: PropTypes.string,
      content: PropTypes.node,
    })
  ).isRequired,
};

const Wrapper = styled.div`
  margin-top: 40px;
  border-top: 1px solid ${colors.Gray};
`;

const Item = styled.div`
  border-bottom: 1px solid ${colors.Gray};
`;

const Header = styled.button`
  ${styl.clear};
  ${styl.boldDefaultFont};
  ${styl.flexRow};
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 22px 0px;
  cursor: pointer;
  font-size: 13px;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-align: left;
  color: ${colors.MineshaftGreyText};

  &:hover {
    color: ${colors.CongressBlueHeader};
  }
`;

const Chevron = styled.span`
  width: 9px;
  height: 9px;
  margin-right: 6px;
  border-right: 1px solid currentColor;
  border-bottom: 1px solid currentColor;
  transform: ${(props) =>
    props.$open ? "translateY(3px) rotate(-135deg)" : "rotate(45deg)"};
  ${styl.transition};
`;

const Content = styled.div`
  ${styl.lightDefaultFont};
  font-size: 14px;
  line-height: 20px;
  font-weight: 300;
  color: ${colors.SolidBlackText};
  padding-bottom: 22px;

  p:first-child {
    margin-top: 0;
  }

  h3 {
    ${styl.boldDefaultFont};
    font-size: 16px;
    margin: 28px 0px 10px 0px;
  }

  ul {
    padding-left: 20px;
    margin: 0;
  }

  li {
    margin-bottom: 6px;
  }

  a {
    color: #b2982a;
  }
`;
